import {Tag} from "@/store/forum/types";

export class EditShare {

    public static titleText: string = '';
    public static hasName: boolean = false;
    public static hasTags: boolean = false;

    public static guest: boolean = false;
    public static canBeGuest: boolean = false;
    public static availableTags: Tag[] = [];

    public static initTitle: string = '';
    public static initText: string = '';
    public static initTags: Tag[] = [];

    public static callback: (topicTitle: string, txt: string, tags: Tag[], guest: boolean, errorCallback: (err: string) => unknown) => unknown;

    public static initPage(title: string, hasName: boolean, hasTags: boolean, topicTitle: string, txt: string, tags: Tag[], guest: boolean, canBeGuest: boolean,
                           callback: (topicTitle: string, txt: string, tags: Tag[], guest: boolean, errorCallback: (err: string) => unknown) => unknown,
                           availableTags: Tag[]) {
        EditShare.titleText = title;
        EditShare.hasName = hasName;
        EditShare.hasTags = hasTags;
        EditShare.callback = callback;
        EditShare.availableTags = availableTags;
        EditShare.guest = guest;
        EditShare.canBeGuest = canBeGuest;

        EditShare.initTitle = topicTitle;
        EditShare.initText = txt;
        EditShare.initTags = tags;
    }
}
